import React from "react";
import NepaliDate from "nepali-date-converter";
import { ADToBS, BSToAD } from "bikram-sambat-js";
import { InputDiv } from "../../assets/StyledComponent/Input/Input.Style";
import { useStore } from "../../store";
import "../TotalExpenseReport/styles.css";
import {
  sCmpUserReportDownloadService,
  sCmpUserReportService,
} from "../../services/sCmpUserReportService";
import {
  GET_CMP_USER_REPORT_FAILURE,
  GET_CMP_USER_REPORT_SUCCESS,
} from "../../container/SCmpUserReport/types";
import { toast } from "react-toastify";
interface Iprops {
  companyId: string;
}
const UserReport = ({ companyId }: Iprops) => {
  const [state, dispatch]: any = useStore();
  const [date, setDate] = React.useState({ year: "", month: "" });

  const month = [
    {
      name: "Baishakh",
      value: "01",
    },
    {
      name: "Jestha",
      value: "02",
    },
    {
      name: "Ashadh",
      value: "03",
    },
    {
      name: "Shrawan",
      value: "04",
    },
    {
      name: "Bhadra",
      value: "05",
    },
    {
      name: "Ashwin",
      value: "06",
    },
    {
      name: "Kartik",
      value: "07",
    },
    {
      name: "Mangsir",
      value: "08",
    },
    {
      name: "poush",
      value: "09",
    },
    {
      name: "Magh",
      value: "10",
    },
    {
      name: "Falgun",
      value: "11",
    },
    {
      name: "Chaitra",
      value: "12",
    },
  ];

  const year = [
    {
      name: "2079",
      value: "2079",
    },
    {
      name: "2080",
      value: "2080",
    },
    {
      name: "2081",
      value: "2081",
    },
    {
      name: "2082",
      value: "2082",
    },
    {
      name: "2083",
      value: "2083",
    },
    {
      name: "2084",
      value: "2084",
    },
    {
      name: "2085",
      value: "2085",
    },
    {
      name: "2086",
      value: "2086",
    },
    {
      name: "2087",
      value: "2087",
    },
    {
      name: "2088",
      value: "2088",
    },
    {
      name: "2089",
      value: "2089",
    },
    {
      name: "2090",
      value: "2090",
    },
  ];

  const getTableData = async () => {
    const fromDate = date && BSToAD(`${date.year}-${date.month}-01`);

    const toDate =
      date && date.month === "12"
        ? BSToAD(`${date.year}-${parseInt(date.month)}-31`)
        : BSToAD(`${date.year}-${parseInt(date.month) + 1}-01`);

    var d = new Date(toDate);
    // console.log("Today is: " + d.toLocaleString());

    d.setDate(d.getDate() - 1);

    const toDate_to_send = d.toLocaleDateString("sv-SE");
    // const year = d.getFullYear().toString();
    // const month = String(d.getMonth() + 1).padStart(2, "0");
    // const day = String(d.getDate()).padStart(2, "0");
    // const to_date = year + "-" + month + "-" + day;
    // console.log("to_date", to_date);

    {
      sCmpUserReportDownloadService(fromDate, toDate_to_send, companyId);
    }
  };

  React.useEffect(() => {
    const currentDate = new NepaliDate(Date.now());
    const startDate = new NepaliDate(
      currentDate.getYear(),
      currentDate.getMonth(),
      1
    ).toJsDate();

    const nepaliStartDate = ADToBS(startDate.toLocaleDateString());
    setDate({
      year: nepaliStartDate.slice(0, 4),
      month: nepaliStartDate.slice(5, 7),
    });
  }, []);

  const handleUserReport = () => {
    const fromDate = date && BSToAD(`${date.year}-${date.month}-01`);

    const toDate =
      date && date.month === "12"
        ? BSToAD(`${date.year}-${parseInt(date.month)}-31`)
        : BSToAD(`${date.year}-${parseInt(date.month) + 1}-01`);

    var d = new Date(toDate);
    // console.log("Today is: " + d.toLocaleString());

    d.setDate(d.getDate() - 1);

    const toDate_to_send = d.toLocaleDateString("sv-SE");

    // const year = d.getFullYear().toString();
    // const month = String(d.getMonth() + 1).padStart(2, "0");
    // const day = String(d.getDate()).padStart(2, "0");
    // const to_date = year + "-" + month + "-" + day;

    sCmpUserReportService(fromDate, toDate_to_send, companyId)
      .then((res: any) => {
        dispatch({ type: GET_CMP_USER_REPORT_SUCCESS, SCmpUserReport: res });
      })
      .catch((err) => {
        dispatch({
          type: GET_CMP_USER_REPORT_FAILURE,
          SCmpUserReportError: err,
        });
        toast.error("Select company");
      });
  };
  return (
    <InputDiv>
      <div
        className="w-80 text-center rounded bg-white d-flex"
        style={
          {
            // width: "68.5%",
            // display: "flex",
            // flexDirection: "row",
            // justifyContent: "space-between",
          }
        }
      >
        <label
          style={{
            whiteSpace: "nowrap",
            display: "flex",
            margin: "0px 20px",
            fontWeight: "500",
          }}
        >
          Select Nepali Year
        </label>
        <select
          style={{
            width: "8.75rem",
            padding: "0.5px 1px",
            borderRadius: "5px",
            background: "white",
          }}
          value={date.year}
          onChange={(e) => setDate({ ...date, year: e.target.value })}
        >
          {year.map((item) => (
            <option value={item.value} key={item.name}>
              {item.name}
            </option>
          ))}
        </select>
        <label
          style={{
            whiteSpace: "nowrap",
            display: "flex",
            marginLeft: "34px",
            marginRight: "20px",
            fontWeight: "500",
          }}
        >
          Select Nepali Month
        </label>
        <select
          style={{
            width: "8.75rem",
            padding: "0.5px 1px",
            borderRadius: "5px",
            background: "white",
          }}
          value={date.month}
          onChange={(e) => setDate({ ...date, month: e.target.value })}
        >
          {month.map((item) => (
            <option value={item.value} key={item.name}>
              {item.name}
            </option>
          ))}
        </select>

        <button className="searchBtn" onClick={getTableData}>
          {" "}
          Download{" "}
        </button>
        <button className="searchBtn" type="button" onClick={handleUserReport}>
          {" "}
          View
        </button>
      </div>
    </InputDiv>
  );
};

export default UserReport;
